// /src/renderer/analysis/rendering/panelRegistry.ts
import React from 'react';

type PanelRegistryType = Record<string, React.FC<any>>;

const registry: PanelRegistryType = {};

export function registerPanel(name: string, component: React.FC<any>) {
  if (!registry[name]) registry[name] = component;
}
export function getPanel(name: string): React.FC<any> {
  return registry[name] ?? (() => null);
}
export function getAllPanels() {
  return registry;
}
